import React, { Component } from "react";

//Components
import ProductHeader from "../../ProductDetails/ProductHeader";
import ActionButton from "../../ActionButton";

//Assets
import { ReactComponent as Error } from "./error.svg";

//Redux
import { connect } from "react-redux";
import { Redirect } from "react-router";

class index extends Component {
  render() {
    const language = this.props.language;
    if (!this.props.history.location.state) return <Redirect to="/" />;
    const errorMessage = this.props.history.location.state.message;
    return (
      <div style={{ backgroundColor: "white", minHeight: window.innerHeight }}>
        <ProductHeader
          onBack={() => {
            this.props.history.goBack();
          }}
        />

        <div className="free-space-190-white"></div>

        <Error width="100" height="100" />

        <h1
          className="mt-3"
          dir={language == "english" ? "ltr" : "rtl"}
          style={{ fontFamily: language == "english" ? "Quicksand" : "Cairo" }}
        >
          {language == "english" ? "Oops.." : "حدث خطأ"}
        </h1>

        <p
          className="mt-3 mx-auto mb-0"
          style={{ fontSize: "1rem", width: "90%" }}
          dir={language == "english" ? "ltr" : "rtl"}
        >
          {errorMessage
            ? errorMessage
            : language == "english"
            ? "Your order has not been placed. Please try again or contact us for help"
            : "عذرا، لم نتمكن من اتمام العملية. يرجى المحاولة مرة اخرى او الاتصال بنا للمساعدة"}
        </p>

        <ActionButton
          action={language == "english" ? "Go back" : "الرجوع"}
          onClick={() => {
            this.props.history.goBack();
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
  };
};

export default connect(mapStateToProps)(index);
